.table {
  border: 0.1px solid var(--mantine-color-gray-5);
  border-collapse: collapse;

  & td,
  & th {
    border: 0.1px solid var(--mantine-color-gray-5);
    padding: 4px;
  }
}

.criticalRow {
  background: light-dark(var(--mantine-color-red-1), var(--mantine-color-red-7));
  border: 0.1px solid var(--mantine-color-red-5);
  color: var(--mantine-color-red-5);
  font-weight: 500;

  & td {
    border: 0.1px solid var(--mantine-color-red-5);
  }
}

.noteBody {
  font-size: var(--mantine-font-size-sm);
}

.noteCite {
  font-size: var(--mantine-font-size-xs);
  margin-block-start: 3;
}

.noteRoot {
  padding: 5px;
}
